import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PopupContext } from 'components';
import { useContext } from 'react';
import PRODUCTS_KEYS from '../products.keys';
import PRODUCTS_MUTATIONS from '../products.mutation';

export const useBulkCreateProducts = () => {
  const queryClient = useQueryClient();
  const { closePopup } = useContext(PopupContext);

  return useMutation({
    mutationFn: PRODUCTS_MUTATIONS.BULK_CREATE_PRODUCTS,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.PRODUCTS() });
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.CHILD_PRODUCTS() });
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.ALL_CHILD_PRODUCTS() });
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.PRODUCT_CATEGORIES() });
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.PRODUCT_INVENTORIES() });
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.PRODUCT_COLORS() });
      queryClient.invalidateQueries({ queryKey: PRODUCTS_KEYS.PRODUCT_SIZES() });
      closePopup?.();
    },
  });
};
